import React from 'react';
import '../../css/main.css';
import API from '../../api/api';
import LinearProgress from '@mui/material/LinearProgress';
import { Component } from 'react';
import SecuredZone from '../../components/SecuredZone';
import linkState from 'linkstate';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { Icon } from '../../icons/AppIcons';
const FireApi = new API();

class Company extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      organisation: {
        name: '',
        road: '',
        lat: '',
        long: '',
        place: '',
        land: '',
        alert_email: '',
        alert_sms: '',
        alert_mail_enabled: 1,
        alert_sms_enabled: 0,
        sms_gateway_url: '',
        sms_gateway_user: '',
        sms_gateway_password: '',
        sms_originator: '',
      },
    };
  }

  componentDidMount() {
    this.getCompany();
  }

  getCompany() {
    FireApi.endpoints.organisation.getAll()
      .then((organisationGet) => {
        if (organisationGet.data) {
          this.setState({ 
            organisation: {
              name: organisationGet.data.name || '',
              road: organisationGet.data.road || '',
              lat: organisationGet.data.lat || '',
              long: organisationGet.data.long || '',
              place: organisationGet.data.place || '',
              land: organisationGet.data.land || '',
              alert_email: organisationGet.data.alert_email || '',
              alert_sms: organisationGet.data.alert_sms || '',
              alert_mail_enabled: organisationGet.data.alert_mail_enabled ? 1 : 0,
              alert_sms_enabled: organisationGet.data.alert_sms_enabled ? 1 : 0,
              sms_gateway_url: organisationGet.data.sms_gateway_url || '',
              sms_gateway_user: organisationGet.data.sms_gateway_user || '',
              sms_gateway_password: organisationGet.data.sms_gateway_password || '',
              sms_originator: organisationGet.data.sms_originator || '',
            }
          });
        }
        this.setState({ loading: false });
      })
      .catch(() => {
        // If organisation doesn't exist yet, just show empty form
        this.setState({ loading: false });
      });
  }

  updateCompany() {
    this.setState({ loading: true });

    const organisationData = {
      name: this.state.organisation.name || '',
      road: this.state.organisation.road || '',
      lat: this.state.organisation.lat ? parseFloat(this.state.organisation.lat) : null,
      long: this.state.organisation.long ? parseFloat(this.state.organisation.long) : null,
      place: this.state.organisation.place || '',
      land: this.state.organisation.land || '',
      alert_email: this.state.organisation.alert_email || '',
      alert_sms: this.state.organisation.alert_sms || '',
      alert_mail_enabled: this.state.organisation.alert_mail_enabled ? 1 : 0,
      alert_sms_enabled: this.state.organisation.alert_sms_enabled ? 1 : 0,
      sms_gateway_url: this.state.organisation.sms_gateway_url || '',
      sms_gateway_user: this.state.organisation.sms_gateway_user || '',
      sms_gateway_password: this.state.organisation.sms_gateway_password || '',
      sms_originator: this.state.organisation.sms_originator || '',
    };

    // Only PUT is supported (no create, no ID needed)
    FireApi.endpoints.organisation.update({ ...organisationData, id: '' })
      .then(() => {
        this.setState({ loading: false });
        this.getCompany();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <SecuredZone 
        title="Firma"
        breadcrumbs={{ '/': 'Dashboard', '/company': 'Firma' }}
        loading={this.state.loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        <div className="settings-form">
          <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Icon name="company" size={22} /> Firma
          </Typography>
          <div className="user-input-linoen">
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.name || ''}
              onInput={linkState(this, 'organisation.name')}
            />
          </div>

          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="road"
              label="Straße"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.road || ''}
              onInput={linkState(this, 'organisation.road')}
            />
          </div>

          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="place"
              label="Ort"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.place || ''}
              onInput={linkState(this, 'organisation.place')}
            />
          </div>

          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="land"
              label="Land"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.land || ''}
              onInput={linkState(this, 'organisation.land')}
            />
          </div>

          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="lat"
              label="Breitengrad (Lat)"
              type="number"
              fullWidth
              variant="outlined"
              value={this.state.organisation.lat || ''}
              onInput={linkState(this, 'organisation.lat')}
              inputProps={{ step: 'any' }}
            />
          </div>
          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="long"
              label="Längengrad (Long)"
              type="number"
              fullWidth
              variant="outlined"
              value={this.state.organisation.long || ''}
              onInput={linkState(this, 'organisation.long')}
              inputProps={{ step: 'any' }}
            />
          </div>

          <Typography variant="h6" sx={{ mt: 4, mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <Icon name="alarm" size={22} /> Alarmierung
          </Typography>
          <div className="user-input-linoen">
            <FormControlLabel
              control={
                <Switch
                  checked={!!this.state.organisation.alert_mail_enabled}
                  onChange={(e) =>
                    this.setState({
                      organisation: { ...this.state.organisation, alert_mail_enabled: e.target.checked ? 1 : 0 },
                    })
                  }
                  color="primary"
                />
              }
              label="E-Mail bei Alarm"
            />
          </div>
          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="alert_email"
              label="E-Mail-Empfänger (kommagetrennt)"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.alert_email || ''}
              onInput={linkState(this, 'organisation.alert_email')}
            />
          </div>
          <div className="user-input-linoen">
            <FormControlLabel
              control={
                <Switch
                  checked={!!this.state.organisation.alert_sms_enabled}
                  onChange={(e) =>
                    this.setState({
                      organisation: { ...this.state.organisation, alert_sms_enabled: e.target.checked ? 1 : 0 },
                    })
                  }
                  color="primary"
                />
              }
              label="SMS bei Alarm"
            />
          </div>
          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="alert_sms"
              label="SMS-Nummern (kommagetrennt, z. B. 4179…)"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.alert_sms || ''}
              onInput={linkState(this, 'organisation.alert_sms')}
            />
          </div>
          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="sms_gateway_url"
              label="SMS-Gateway URL (JSON POST)"
              type="text"
              fullWidth
              variant="outlined"
              placeholder="https://json.aspsms.com/SendSimpleTextSMS"
              value={this.state.organisation.sms_gateway_url || ''}
              onInput={linkState(this, 'organisation.sms_gateway_url')}
            />
          </div>
          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="sms_gateway_user"
              label="SMS-Gateway Benutzer"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.sms_gateway_user || ''}
              onInput={linkState(this, 'organisation.sms_gateway_user')}
            />
          </div>
          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="sms_gateway_password"
              label="SMS-Gateway Passwort"
              type="password"
              fullWidth
              variant="outlined"
              value={this.state.organisation.sms_gateway_password || ''}
              onInput={linkState(this, 'organisation.sms_gateway_password')}
            />
          </div>
          <div className="user-input-linoen">
            <TextField
              margin="dense"
              id="sms_originator"
              label="SMS Absender"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.organisation.sms_originator || ''}
              onInput={linkState(this, 'organisation.sms_originator')}
            />
          </div>

          {/* Save Button */}
          <div className="user-input-boetton" style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => { this.updateCompany(); }}
              size="large"
            >
              Speichern
            </Button>
          </div>
        </div>
      </SecuredZone>
    );
  }
}

export default Company;
